import React from "react";
import C from "classnames";

interface DrawerContentProps {
  title?: string;
  className?: string;
  children?: React.ReactNode;
  openDrawer?: () => void;
  isOpenValue?: boolean;
  onBadgeClearRef?: React.MutableRefObject<(() => void) | null>;
  updateBadge?: (value: number | string | undefined) => void;
}

const DrawerContent: React.FC<DrawerContentProps> = ({
  className,
  children,
  openDrawer,
  isOpenValue,
  onBadgeClearRef,
  updateBadge,
}) => {
  return (
    <div className={C("h-full", className)}>
      {React.Children.map(children, child => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {
            openDrawer,
            isOpenValue,
            onBadgeClearRef,
            updateBadge,
          });
        }
        return child;
      })}
    </div>
  );
};

export default DrawerContent;
